import createIcon from '../../createIcon';

/**
 * @component @name PersonOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS4zNTk2MSA1LjEwOTYxQzEwLjA2OTYgNC4wMDk2MSAxMS4zMDk2IDMuMjg5NjEgMTIuNzA5NiAzLjI4OTYxQzE0LjkxOTYgMy4yODk2MSAxNi43MDk2IDUuMDc5NjEgMTYuNzA5NiA3LjI4OTYxQzE2LjcwOTYgOC42ODk2MSAxNS45ODk2IDkuOTI5NjEgMTQuODg5NiAxMC42Mzk2TDkuMzU5NjEgNS4xMDk2MVpNMjAuNzA5NiAxNi40NTk2QzIwLjY4OTYgMTUuMzU5NiAyMC4wNzk2IDE0LjM0OTYgMTkuMDk5NiAxMy44Mzk2QzE4LjU1OTYgMTMuNTU5NiAxNy45Njk2IDEzLjI5OTYgMTcuMzI5NiAxMy4wNzk2TDIwLjcwOTYgMTYuNDU5NlpNMjEuODk5NiAyMC40Nzk2TDMuNTE5NjEgMi4wOTk2MUwyLjA5OTYxIDMuNTA5NjFMMTAuOTg5NiAxMi4zOTk2QzkuMTc5NjEgMTIuNjI5NiA3LjU5OTYxIDEzLjE4OTYgNi4zMTk2MSAxMy44NDk2QzUuMzE5NjEgMTQuMzU5NiA0LjcwOTYxIDE1LjM4OTYgNC43MDk2MSAxNi41MDk2VjE5LjI4OTZIMTcuODc5NkwyMC40ODk2IDIxLjg5OTZMMjEuODk5NiAyMC40Nzk2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PersonOff = createIcon('PersonOff', [
  [
    'path',
    {
      d: 'M9.35961 5.10961C10.0696 4.00961 11.3096 3.28961 12.7096 3.28961C14.9196 3.28961 16.7096 5.07961 16.7096 7.28961C16.7096 8.68961 15.9896 9.92961 14.8896 10.6396L9.35961 5.10961ZM20.7096 16.4596C20.6896 15.3596 20.0796 14.3496 19.0996 13.8396C18.5596 13.5596 17.9696 13.2996 17.3296 13.0796L20.7096 16.4596ZM21.8996 20.4796L3.51961 2.09961L2.09961 3.50961L10.9896 12.3996C9.17961 12.6296 7.59961 13.1896 6.31961 13.8496C5.31961 14.3596 4.70961 15.3896 4.70961 16.5096V19.2896H17.8796L20.4896 21.8996L21.8996 20.4796Z',
      key: 'nr8ev5',
    },
  ],
]);

export default PersonOff;
